/* eslint @typescript-eslint/no-explicit-any: 0 */
/* eslint @typescript-eslint/no-unused-vars: 0 */

import { Dictionary } from "./types";

class Socket {
    private socket: WebSocket | null;
    private reconnectAttempts: number;
    private maxReconnectAttempts: number;
    private url: string;
    private listeners: Dictionary<any>;

    constructor(url: string, maxReconnectAttempts: number = 5) {
        this.socket = null;
        this.url = url;
        this.maxReconnectAttempts = maxReconnectAttempts;
        this.reconnectAttempts = 0;
        this.listeners = {};
    }

    connect() {
        if (!this.socket) {
            this.socket = new WebSocket(this.url);

            // add listeners
            for (const eventName in this.listeners) {
                this.socket.addEventListener(eventName, this.listeners[eventName]);
            }

            // reconnect logic
            this.socket.onopen = (event) => {
                if ("open" in this.listeners) {
                    this.listeners["open"](event);
                }
                this.reconnectAttempts = 0;
            };

            this.socket.onclose = (event) => {
                if ("close" in this.listeners) {
                    this.listeners["close"](event);
                }
                this.reconnect();
            };
        }
    }

    disconnect() {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
            this.reconnectAttempts = 0;
        }
    }

    send(message: any) {
        if (this.socket) {
            this.socket.send(JSON.stringify(message));
        }
    }

    on(eventName: string, callback: any) {
        this.listeners[eventName] = callback;
    }

    isConnected() {
        return this.socket !== null;
    }

    reset() {
        this.disconnect();
        this.listeners = {};
    }

    private reconnect() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            setTimeout(() => {
                this.reconnectAttempts++;
                this.connect();
            }, Math.pow(2, this.reconnectAttempts) * 1000);
        }
    }
}

export { Socket };
